<template>
  <div class="placement-info">
    <div class="place-name">
      <b>{{placement_attrs.hotel_name}}</b>
      <br>
      {{placement_attrs.room_name}}
      <br>
      <small class="text-muted">{{placement_attrs.human_description}}</small>
    </div>


    <div class="placement-price">
      <template v-if="placement_attrs.price_by_course > 0">

        <b-badge  variant="light">
          {{placement_attrs.price_by_course}}р.
        </b-badge>
<!--        <b-badge v-if="main_group" variant="light">-->
<!--          {{placement_attrs.price_by_course}}р.-->
<!--        </b-badge>-->
<!--        <b-badge v-else variant="light">-->
<!--          Доплата {{placement_attrs.price_by_course}}р.-->
<!--        </b-badge>-->

      </template>
      <template v-if="placement_attrs.price_by_course < 0">
        <b-badge variant="danger">
           Скидка
        </b-badge>

      </template>
      <template v-if="placement_attrs.price_by_course == 0">
        <b-badge variant="success">
          Включено
        </b-badge>
      </template>
    </div>
    <div class="placement-quantity">
      <b-badge :variant="quantity > 1 ? 'secondary' : 'light'">x {{quantity}}</b-badge>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    placement: Object,
    main_group: Boolean,
  },
  data(){
    return {
      placement_attrs: this.placement.placement.attributes,
      quantity: this.placement.quantity,
    }
  },
  watch: {
    placement(new_value){
      // console.log('placement changed');
      this.$set(this, 'placement_attrs', new_value);
    }
  },
  beforeUpdate() {
    this.$set(this, 'placement_attrs', this.placement.placement.attributes);
    this.$set(this, 'quantity', this.placement.quantity);
  },


}
</script>
<style>
.placement-info{
  display: flex;
}
</style>